import {
  Button,
  Column,
  Columns,
  FieldLabel,
  Icon,
  Stack,
} from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'

import React from 'react'
import { ApiCustomer } from '@vend/types'
import { CustomerBadge } from '@vend/react-utilities'
import { PartialCustomerGroup } from '../../../../react/modals/common/types'
import { LineItemFulfilmentCustomerHeaderView } from './LineItemFulfilmentCustomerHeaderView'
import { LineItemFulfilmentCustomerContactView } from './LineItemFulfilmentCustomerContactView'

export type Props = {
  onRemoveCustomer: () => void
  onEmailChange: (email: string) => void
  onPhoneNumberChange: (phoneNumberType: string, phoneNumber: string) => void
  isEmailInvalid: boolean
  customer: ApiCustomer
  customerGroup?: PartialCustomerGroup
}

export const LineItemFulfilmentCustomerDetailsView: React.FC<Props> = ({
  onRemoveCustomer,
  onEmailChange,
  onPhoneNumberChange,
  isEmailInvalid,
  customer,
  customerGroup,
}) => {
  const t = useT()
  return (
    <Stack space={6}>
      <LineItemFulfilmentCustomerHeaderView />
      <Stack space={0}>
        <FieldLabel label={t('Customer')} />
        <Columns space={0} alignY="center">
          <Column>
            <CustomerBadge
              apiCustomer={customer}
              group={customerGroup}
              size="x-small"
            />
          </Column>
          <Column width="content">
            <Button
              variant="no"
              modifier="icon"
              onClick={onRemoveCustomer}
              aria-label={t('Delete customer')}
              data-track="remove-customer"
            >
              <Icon icon="fa-trash" />
            </Button>
          </Column>
        </Columns>
      </Stack>
      <LineItemFulfilmentCustomerContactView
        customer={customer}
        onEmailChange={onEmailChange}
        onPhoneNumberChange={onPhoneNumberChange}
        isEmailInvalid={isEmailInvalid}
      />
    </Stack>
  )
}
